import moment from 'moment';
import i18n from 'i18n';
import { LanguageDetectorModule } from 'i18next';
import Cookies from 'js-cookie';
import { getDiscoverySettingLanguage } from 'xcipio/discovery-xcipio-selectors';
import { RootState } from 'data/root.reducers';
import {
  DEFAULT_LANGUAGE,
  DX_LANGUAGE_KEY,
  VIETNAMESE_LANGUAGES_CODES,
  XMS_LANGUAGE_KEY,
  XMS_LANGUAGE_MAP,
} from './i18n.types';

export function isNavigatorInVietnamese(): boolean {
  return VIETNAMESE_LANGUAGES_CODES.includes(navigator.language);
}

export function getNavigatorLanguage(): string {
  if (isNavigatorInVietnamese()) {
    return 'vi';
  }

  return DEFAULT_LANGUAGE;
}

export function getNavigatorLanguages(): string[] {
  const languages: string[] = [];

  if (navigator.languages) {
    for (let i = 0; i < navigator.languages.length; i += 1) {
      languages.push(navigator.languages[i]);
    }
  }

  if (navigator.language) {
    languages.push(navigator.language);
  }

  return languages;
}

// Define the language detector to detect the language defined in localStorage
// and also save it to localStorage and the expected cookie for XMS.
export const languageDetector: LanguageDetectorModule = {
  type: 'languageDetector',
  init: () => {},
  detect: () => {
    const language = localStorage.getItem(DX_LANGUAGE_KEY) ?? DEFAULT_LANGUAGE;

    // Set moment language
    moment.locale(language);

    return language;
  },
  cacheUserLanguage: (language: string) => {
    localStorage.setItem(DX_LANGUAGE_KEY, language);
    Cookies.set(
      XMS_LANGUAGE_KEY,
      XMS_LANGUAGE_MAP[language] ?? XMS_LANGUAGE_MAP[DEFAULT_LANGUAGE],
    );
  },
};

export function missingKeyHandler(_lngs: string[], _ns: string, key: string, fallbackValue: string): void {
  let message = '';
  if (key === fallbackValue) {
    message = `"${key}": "?"`;
  } else {
    message = `"${key}": "${fallbackValue}"`;
  }

  // eslint-disable-next-line no-console
  console.info('i18n', `Missing key ${message}`);
}

export function maybeSetLanguage(state: RootState): void {
  const language = getDiscoverySettingLanguage(state);

  if (language === 'en-GB' && i18n.language === DEFAULT_LANGUAGE) {
    // Change from English to British English
    i18n.changeLanguage(language);
  }
}

export function removeDiacritic(string: string): string {
  return string.normalize('NFD').replace(/\p{Diacritic}/gu, '');
}
